import React, { PropsWithChildren, ReactNode, useMemo } from 'react';
import cx from 'classnames';
import { DragDropContext, Draggable, Droppable, OnDragEndResponder } from '@hello-pangea/dnd';
import { addUniqueIDsToArrayItems } from 'new/utils';

import s from './DraggableVerticalList.module.scss';

type Props = {
  items: Array<any>;
  listClassname?: string;
  onDragEnd: OnDragEndResponder;
  renderDraggableList(items: Array<any>): ReactNode[];
};

export function DraggableVerticalList(props: PropsWithChildren<Props>) {
  const { onDragEnd, renderDraggableList, items = [], listClassname } = props;

  if (!Array.isArray(items)) {
    console.info('items must be an array');
    return null;
  }

  const formattedDraggableList = useMemo(() => {
    if (items.some((item) => !item.__id)) {
      return addUniqueIDsToArrayItems(items);
    }

    return items;
  }, [items]);

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="DraggableVerticalList">
        {(provided) => (
          <ol
            ref={provided.innerRef}
            className={cx(s.container, listClassname)}
            {...provided.droppableProps}
          >
            {renderDraggableList(formattedDraggableList)}
            {provided.placeholder}
          </ol>
        )}
      </Droppable>
    </DragDropContext>
  );
}

DraggableVerticalList.Draggable = Draggable;
